import React, { Component } from "react";
import {BrowserRouter,Routes,Route,useNavigate,useLocation,} from "react-router-dom";
import { Navigate } from "react-router-dom";
import Login from "./screens/Login";
import Register from "./screens/Register";
import Home from "./screens/Home";
import Game from "./screens/Game";
import History from "./screens/History";
import AdminLogin from "./screens/AdminLogin";
import AdminDashboard from "./screens/AdminDashboard";
import AdminUsers from "./screens/AdminUsers";
import AdminRevenue from "./screens/AdminRevenue";
import AdminMatches from "./screens/AdminMatches";
import TransactionHistory from "./screens/TransactionHistory"
import Deposit from "./screens/Deposit";
import AdminDeposits from "./screens/AdminDeposits";
import Withdraw from "./screens/Withdraw";
import AdminWithdraws from "./screens/AdminWithdraws";
import Profile from "./screens/Profile";
import ForgotPassword from "./screens/ForgotPassword";

// 🔥 WRAPPERS (VERY IMPORTANT)

function LoginWrapper() {
  const navigate = useNavigate();
  return <Login navigate={navigate} />;
}

function RegisterWrapper() {
  const navigate = useNavigate();
  return <Register navigate={navigate} />;
}

function HomeWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  return <Home navigate={navigate} location={location} />;
}

function GameWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  return <Game navigate={navigate} location={location} />;
}
function HistoryWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  return (<History navigate={navigate} location={location}
  />
  );
}
function AdminLoginWrapper() {
  const navigate = useNavigate();
  return <AdminLogin navigate={navigate} />;
}
function AdminDashboardWrapper() {
  const navigate = useNavigate();
  return <AdminDashboard navigate={navigate} />;
}
function AdminUsersWrapper() {
  const navigate = useNavigate();
  return <AdminUsers navigate={navigate} />;
}
function AdminRevenueWrapper() {
  const navigate = useNavigate();
  return <AdminRevenue navigate={navigate} />;
}

function AdminMatchesWrapper() {
  const navigate = useNavigate();
  return <AdminMatches navigate={navigate} />;
}
function TransactionHistoryWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <TransactionHistory navigate={navigate} location={location} />);
}

function DepositWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  return (<Deposit navigate={navigate} location={location} />);
}

function AdminDepositsWrapper() {
  const navigate = useNavigate();
  return (<AdminDeposits navigate={navigate} />);
}

function WithdrawWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  return (<Withdraw navigate={navigate} location={location} />);
}

function AdminWithdrawsWrapper() {
  const navigate = useNavigate();
  return (<AdminWithdraws navigate={navigate} />);
}

function ProfileWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Profile navigate={navigate} location={location} />);
}
function ForgotPasswordWrapper() {
 const navigate =  useNavigate();
return ( <ForgotPassword  navigate={navigate} />);
}

// function ProtectedRoute({ children }) {
//   const user = localStorage.getItem("user");
//   if (!user) {
//     return (<Navigate to="/" replace />
//       // <LoginWrapper />
//     );
//   }
//   return children;
// }

function ProtectedRoute({ children }) {

  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function AdminProtectedRoute({ children }) {

  const token = localStorage.getItem("adminToken");

  if (!token) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
// function AdminProtectedRoute({ children }) {
//   const admin =
//     localStorage.getItem("admin");
//   if (!admin) {
//     return (<Navigate to="/admin" replace />
//       // <AdminLoginWrapper />
//     );
//   }
//   return children;
// }


// ✅ MAIN APP


class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminLoginWrapper />} />
          <Route path="/admin-dashboard" element={< AdminProtectedRoute><AdminDashboardWrapper /></AdminProtectedRoute>} />
          <Route path="/admin-users" element={< AdminProtectedRoute> <AdminUsersWrapper /></AdminProtectedRoute>} />
          <Route path="/admin-revenue" element={< AdminProtectedRoute><AdminRevenueWrapper /></AdminProtectedRoute>} />
          <Route path="/admin-matches" element={< AdminProtectedRoute><AdminMatchesWrapper /></AdminProtectedRoute>} />
          <Route path="/" element={<LoginWrapper />} />
          <Route path="/register" element={<RegisterWrapper />} />
          <Route path="/home" element={<ProtectedRoute> <HomeWrapper /></ProtectedRoute>} />
          <Route path="/game" element={<ProtectedRoute><GameWrapper /></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><HistoryWrapper /></ProtectedRoute>} />
          <Route path="/transactions" element={<ProtectedRoute>  <TransactionHistoryWrapper /> </ProtectedRoute>} />
          <Route path="/deposit" element={<ProtectedRoute> <DepositWrapper /> </ProtectedRoute>} />
          <Route path="/admin-deposits" element={<AdminProtectedRoute>  <AdminDepositsWrapper /> </AdminProtectedRoute>} />
          <Route path="/withdraw" element={<ProtectedRoute> <WithdrawWrapper /> </ProtectedRoute>} />
          <Route path="/admin-withdraws" element={<AdminProtectedRoute> <AdminWithdrawsWrapper /></AdminProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute> <ProfileWrapper /></ProtectedRoute>}  />
          <Route path="/forgot-password" element={ <ForgotPasswordWrapper />}/>
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;